// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__PSNX3","wrapImg":"styles_wrapImg__1JAvl","wrapLogoText":"styles_wrapLogoText__2r-X5","wrapSelect":"styles_wrapSelect__31BQt"};